export default __webpack_public_path__ + "static/plierrack-52fc0edb50d541349acd538579153796.png";